export enum QueryParamEnum {
    VENUE_ID = 'venueId',
    // Surfaces a venue at the top of the explore results WITHOUT opening its detail modal
    // (unlike VENUE_ID, which useVenueDialog turns into a modal). Used when a venue is picked
    // from a search box that navigates to the explore grid.
    PINNED_VENUE_ID = 'pinnedVenueId',
    QUERY = 'query',
    PREVIEW = 'preview',
    EDIT = 'edit',
    CREATE_EVENT = 'createEvent',
    AUTO_CREATE_EVENT = 'autoCreateEvent',
}
